import repository from "../Repository";

export default {
  list(screenId, category) {
    return repository.post(
      `system_info`,
      { category: category },
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
